import Head from 'next/head';
import React from 'react';

import { sales, support, datacampAddress } from '@siteData';

const structuredJSON = `{
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "CDN77",
  "url": "https://www.cdn77.com/",
  "logo": "https://www.cdn77.com/cdn77.svg",
  "description": "Content Delivery Network trusted by Space Agencies",
  "foundingDate": "2011",
  "founder": {
    "@type": "Person",
    "name": "Zdenek Cendra",
    "jobTitle": "Founder & CEO"
  },
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "${datacampAddress.street}",
    "addressLocality": "${datacampAddress.cityDistrict}",
    "addressRegion": "${datacampAddress.city}",
    "postalCode": "${datacampAddress.postalCode}",
    "addressCountry": "${datacampAddress.countryCode}"
  },
  "contactPoint": [{
    "@type": "ContactPoint",
    "contactType": "sales",
    "email": "${sales.email}",
    "availableLanguage": [
      "English",
      "Spanish"
    ]
  },{
    "@type": "ContactPoint",
    "contactType": "technical support",
    "email": "${support.email}",
  }],
  "sameAs": [ 
    "https://www.linkedin.com/company/cdn77-com/",
    "https://twitter.com/cdn77com",
    "https://www.facebook.com/cdn77com/",
    "https://www.g2.com/products/cdn77-com/reviews",
    "https://www.trustpilot.com/review/www.cdn77.com",
    "https://www.crunchbase.com/organization/cdn77-com",
    "https://crozdesk.com/it/content-delivery-network-cdn-software/cdn77"
  ]
}`;

export const ContactStructuredData: React.FC = () => (
  <Head>
    <script
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: structuredJSON,
      }}
      // eslint-disable-next-line react/no-danger
      type="application/ld+json"
    />
  </Head>
);
